export default __webpack_public_path__ + "static/media/logo2.d2a329a4.svg";